module.exports = __webpack_public_path__ + "img/znt-mob.603e9ced.png";